import React from "react";
import { ChecklistPage } from "../pages/ChecklistPage";

/**
 * ChecklistSection
 * Wrapper component for Dashboard integration
 * Renders the ChecklistPage component
 */
export const ChecklistSection: React.FC = () => {
  return <ChecklistPage />;
};

